import { Variables } from 'react-relay';
import { MockResponseConfig } from '../getMockResponse';
import { mockFullLoggedOutUser } from './mockFullLoggedOutUser';

export const mockFullLoggedOutUserTwoGroups: MockResponseConfig = {
  ...mockFullLoggedOutUser,
  UnifiedForumsGroupsQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          __typename: 'UnifiedProfile',
          id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889',
          forums: {
            __typename: 'UnifiedForums',
            id: 'ari:cloud:unified-portable-profile::forums/723',
            groups: {
              __typename: 'UnifiedForumsGroupsConnection',
              edges: [
                {
                  cursor: '0',
                  node: {
                    viewHref: '/t5/Welcome-Center/gh-p/WelcomeCenter',
                    title: 'Welcome Center',
                    groupMemberCount: 11,
                    topicsCount: 6,
                    hasHiddenAncestor: false,
                    aaid: '62587f99fdb60b0069294184',
                    joinDate: '2022-06-23T16:50:44Z',
                    membershipType: 'open',
                    avatar: {
                      mediumHref: '',
                    },
                    id: 'ari:cloud:unified-portable-profile::forums/723/groups/grouphub:WelcomeCenter',
                  },
                },
                {
                  cursor: '1',
                  node: {
                    viewHref: '/t5/Toronto-AUG/gh-p/TorontoAUG',
                    title: 'Toronto AUG',
                    groupMemberCount: 2,
                    topicsCount: 1,
                    aaid: '62587f99fdb60b0069294184',
                    hasHiddenAncestor: false,
                    joinDate: '2022-06-23T17:03:20Z',
                    membershipType: 'open',
                    avatar: {
                      mediumHref: '',
                    },
                    id: 'ari:cloud:unified-portable-profile::forums/723/groups/grouphub:TorontoAUG',
                  },
                },
              ],
              totalCount: 2,
            },
          },
        },
      },
    },
  }),
};
